export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // eslint-disable-line no-useless-escape
  return emailRegex.test(email)
}
